import { PlatformConfig } from '../../config';

interface OgParams {
    assetSymbol: string;
    title: string;
    description?: string;
    overrideSiteUrl?: string;
    platform?: Platform;
    subtitle?: string;
}

type Platform = 'default' | 'x';

const buildAssetOgImg = ({
    assetSymbol,
    title,
    description,
    overrideSiteUrl,
    subtitle,
    platform = 'default',
}: OgParams): string => {
    const params = new URLSearchParams();
    params.append('title', title);
    params.append('assetSymbol', assetSymbol);
    if (subtitle) {
        params.append('subtitle', subtitle);
    }
    params.append('platform', platform);
    if (description) {
        params.append('description', description);
    }
    const imageUrl = `${overrideSiteUrl ?? PlatformConfig.SITE_URL}/api/og?${params.toString()}`;
    return imageUrl;
};

export { buildAssetOgImg };
